/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Tokens
 */
export interface Tokens {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof Tokens
     */
    readonly $schema?: string;
    /**
     * 
     * @type {string}
     * @memberof Tokens
     */
    accessToken: string;
    /**
     * 
     * @type {number}
     * @memberof Tokens
     */
    expiresIn: number;
    /**
     * 
     * @type {string}
     * @memberof Tokens
     */
    idToken: string;
    /**
     * 
     * @type {string}
     * @memberof Tokens
     */
    refreshToken: string;
    /**
     * 
     * @type {string}
     * @memberof Tokens
     */
    tokenType: string;
}

/**
 * Check if a given object implements the Tokens interface.
 */
export function instanceOfTokens(value: object): value is Tokens {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined) return false;
    if (!('idToken' in value) || value['idToken'] === undefined) return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    if (!('tokenType' in value) || value['tokenType'] === undefined) return false;
    return true;
}

export function TokensFromJSON(json: any): Tokens {
    return TokensFromJSONTyped(json, false);
}

export function TokensFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tokens {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'accessToken': json['access_token'],
        'expiresIn': json['expires_in'],
        'idToken': json['id_token'],
        'refreshToken': json['refresh_token'],
        'tokenType': json['token_type'],
    };
}

export function TokensToJSON(json: any): Tokens {
    return TokensToJSONTyped(json, false);
}

export function TokensToJSONTyped(value?: Omit<Tokens, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'access_token': value['accessToken'],
        'expires_in': value['expiresIn'],
        'id_token': value['idToken'],
        'refresh_token': value['refreshToken'],
        'token_type': value['tokenType'],
    };
}

